/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react'
import { PropTypes, node } from "prop-types"
import { NavDropdown, ListGroupItem } from "react-bootstrap"
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import logo from "../../images/PinStar-50PX.png"
import logocollegiatelarge from "../../images/COLLEGIATE-250PXw.png"
import userManager from "../../userManager"
import isEmpty  from '../../utils/isEmpty'
import { GetEditProfileURL } from '../../config'
import HeaderRun from "./Header.run"

const CustomListGroup = ({ children }) => <ul className="list-group">{children}</ul>;

CustomListGroup.propTypes = {
  children: node,
}

class Header extends Component {
  constructor(props) { 
    super(props)
    this.handleSignOut = this.handleSignOut.bind(this)
    this.handleEditProfile = this.handleEditProfile.bind(this)
  }
  componentDidMount() {
    HeaderRun()
  }
  handleSignOut()
  {
    console.log('Signing out')
    userManager.signoutRedirect()
  }
  handleEditProfile()
  {
    window.location = GetEditProfileURL()
  }
  render() {
   const { userName } = this.props

    return (
      <header className="topnavbar-wrapper">
        {/* START Top Navbar */}
        <nav role="navigation" className="navbar topnavbar">
          {/* START navbar header */}
          <div className="navbar-header">
            <a href="#/" className="navbar-brand" style={{ marginTop:'-6px' }}>
              <div className="brand-logo">
                <img src={logocollegiatelarge} alt="App Logo" className="img-responsive" />
              </div>
              <div className="brand-logo-collapsed">
                <img src={logo} alt="App Logo" className="img-responsive" />
              </div>
            </a>
          </div>
          {/* END navbar header */}
          {/* START Nav wrapper */}
          <div className="nav-wrapper">
            {/* START Left navbar */}
            <ul className="nav navbar-nav">
              <li>
                {/* Button used to collapse the left sidebar. Only visible on tablet and desktops */}
                <a href="#" data-trigger-resize="" data-toggle-state="aside-collapsed" className="hidden-xs">
                  <em className="fa fa-navicon" />
                </a>
                {/* Button to show/hide the sidebar on mobile. Visible on mobile only. */}
                <a href="#" data-toggle-state="aside-toggled" data-no-persist="true" className="visible-xs sidebar-toggle">
                  <em className="fa fa-navicon" />
                </a>
              </li>
            </ul>
            {/* END Left navbar */}
            <ul className="nav navbar-nav navbar-middle" style={{ paddingLeft:'33.5%' }}>
              {<h2 style={{ color: 'rgb(98,101,103)', marginTop: "10px" }}>{'Archive'}</h2> }
            </ul>
            {/* START Right Navbar */}
            <ul className="nav navbar-nav navbar-right">
            
              <NavDropdown title={userName} className="dropdown-list" id="user-nav-dropdown">
                <CustomListGroup>
                  <ListGroupItem href="javascript:void(0)">
                    <div className="clearfix">
                      <div className="pull-left">
                        <em className="fa fa-pencil text-muted mr-sm" />
                      </div>
                      <span onClick = {this.handleEditProfile}>Edit Profile</span>
                    </div>
                  </ListGroupItem>
                 
                  <ListGroupItem href="javascript:void(0)">
                    <div className="clearfix text-danger" onClick={this.handleSignOut}>
                      <div className="pull-left">
                        <em className="fa fa-power-off mr-sm" />
                      </div>
                      Sign Out
                    </div>
                  </ListGroupItem>
                </CustomListGroup>
              </NavDropdown>
            </ul>
            {/* END Right Navbar */}
          </div>
          {/* END Nav wrapper */}
        </nav>
        {/* END Top Navbar */}
      </header>
    )
  }
}
Header.propTypes = {
  userName:PropTypes.string
}
function mapDispatchToProps(dispatch){
    return bindActionCreators({
     
      },dispatch)
  }
const mapStateToProps = ({  oidc }) => {
    let userName = ''

    if(oidc.user != null)
    {
      const { profile } = oidc.user
      const firstName = profile.given_name
      const lastName  = profile.family_name
      userName = (!isEmpty(firstName)  && !isEmpty(lastName)) ? firstName + ' ' + lastName : profile.email
    }

    return {
        userName
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/layout/Header.js